import {ReactNode} from 'react';
import {LocaleCode, ResponsiveImage} from '@legit-health/ui';
import {Box, Button, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {Modal} from '@/shared/components/ui/Modal';
import useLocale from '@/shared/hooks/useLocale';
import AddToHomePromptContext from './AddToHomePromptContext';
import safari1 from './images/safari-1.jpg';
import safari2En from './images/safari-2-en.jpg';
import safari2Es from './images/safari-2-es.jpg';
import useAddToHomeScreenPrompt from './useAddToHomeScreenPrompt';

export default function AddToHomePromptContextProvider({children}: {children: ReactNode}) {
  const value = useAddToHomeScreenPrompt();
  const locale = useLocale();
  const {t} = useTranslation(['shared/common']);

  return (
    <AddToHomePromptContext.Provider value={value}>
      {children}
      <Modal
        fullWidth
        title={t('shared/common:install.action')}
        isOpened={value.showSafariModal && !value.hasFinishedInstallation}
        onClose={value.closeIosModal}
        size="xs"
      >
        {value.showSafariModal && !value.hasFinishedInstallation && (
          <div>
            <Box
              sx={{
                mb: 2
              }}
            >
              <Typography
                sx={{
                  mb: '16px'
                }}
              >
                1. {t('shared/common:install.safari1')}
              </Typography>
              <ResponsiveImage src={safari1} alt={t('shared/common:install.safari1')} />
            </Box>
            <Box
              sx={{
                mb: 2
              }}
            >
              <Typography
                sx={{
                  mb: '16px'
                }}
              >
                2. {t('shared/common:install.safari2')}
              </Typography>
              <ResponsiveImage
                src={locale === LocaleCode.Spanish ? safari2Es : safari2En}
                alt={t('shared/common:install.safari2')}
              />
            </Box>
            <Box>
              <Button
                variant="contained"
                color="primary"
                disableElevation
                onClick={value.finishInstallation}
                fullWidth
              >
                {t('shared/common:finish')}
              </Button>
            </Box>
          </div>
        )}
      </Modal>
    </AddToHomePromptContext.Provider>
  );
}
